module.exports = __webpack_public_path__ + "img/parallel-car02.dc60bb33.jpg";